export default __webpack_public_path__ + "static/media/8.04d4a5ff.png";